import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComposerFocusService {
  private readonly focusRequests = new Subject<void>();
  readonly focusRequests$: Observable<void> = this.focusRequests.asObservable();

  requestFocus(): void {
    this.focusRequests.next();
  }
}
